export default "__VITE_ASSET__DIynt3Rx__"